<template>
  <div class="gk-header">
    <div class="container">
      <div class="gk-logo">
        <a href="/"><img src="/packs/assets/images/brands/logo-full-dark.png" alt="Logo PemKab Gunungkidul"></a>
        <!-- <img v-bind:src="logo" alt="Logo PemKab Gunungkidul"> -->
      </div>
      <span class="toggle-menu-m" @click="mobileMenuOpen" v-if="toggleMenu">
        <i class="fas fa-bars"></i>
      </span>
      <transition name="slide-fade">
        <div class="gk-menu" v-bind:class="{ open : menuOpen }" v-if="menuHeader">
          <span class="toggle-close" @click="mobileMenuClose">
            <i class="fa fa-times"></i>
          </span>
          <ul class="menu">
            <li v-bind:class="{ 'active' : isActive == 'home' }">
              <a href="/" class="menu-link">Beranda</a>
            </li>
            <li class="has-submenu" v-bind:class="{ 'active' : isActive == 'profil' }">
              <a href="/profil" class="menu-link">Profil</a>
              <ul class="submenu">
                <li>
                  <a href="/profil" class="submenu-link">Profil</a>
                </li>
                <li>
                  <a href="/tugas_fungsi" class="submenu-link">Tugas & Fungsi</a>
                </li>
                <li>
                  <a href="/struktur_organisasi" class="submenu-link">Struktur Organisasi</a>
                </li>
                <li>
                  <a href="/regulasi" class="submenu-link">Regulasi</a>
                </li>
                <li>
                  <a href="/ppid_pembantu" class="submenu-link">PPID Pembantu</a>
                </li>
              </ul>
            </li>
            <li v-bind:class="{ 'active' : isActive == 'daftar_informasi_publik' }">
              <a href="/data/berkala" class="menu-link">Daftar Informasi</a>
            </li>
            <li class="has-submenu" v-bind:class="{ 'active' : isActive == 'data_informasi_publik' }">
              <a href="/data" class="menu-link">Informasi Publik</a>
              <ul class="submenu">
                <li>
                  <a href="/data?classification_id=1" class="submenu-link">Informasi Berkala</a>
                </li>
                <li>
                  <a href="/data?classification_id=2" class="submenu-link">Informasi Setiap Saat</a>
                </li>
                <li>
                  <a href="/data?classification_id=3" class="submenu-link">Informasi Serta Merta</a>
                </li>
                <li>
                  <a href="/data" class="submenu-link">Informasi Publik</a>
                </li>
              </ul>
            </li>
            <li class="has-submenu" v-bind:class="{ 'active' : isActive == 'layanan' }">
              <a href="javascript:void(0)" class="menu-link">Layanan</a>
              <ul class="submenu">
                <li>
                  <a href="/tatacara_permohonan_informasi" class="submenu-link">Prosedur Layanan</a>
                </li>
                <li>
                  <a href="/requests/new" class="submenu-link">Permohonan Informasi</a>
                </li>
                <li>
                  <a href="/requests" class="submenu-link">Cek Permohonan</a>
                </li>
                <li>
                  <a href="/requests/new_appeals" class="submenu-link">Pengajuan Keberatan</a>
                </li>
                <li>
                  <a href="/data/organizations" class="submenu-link">Statistik</a>
                </li>
              </ul>
            </li>
            <li  class="has-submenu" v-bind:class="{ 'active' : isActive == 'berita' }">
              <a href="/berita/online" class="menu-link">Berita</a>
              <ul class="submenu">
                <li><a href="/agenda/bupati" class="submenu-link">Agenda</a></li>
                <li><a href="/berita" class="submenu-link">Berita Pemkab</a></li>
                <li><a href="/berita/online" class="submenu-link">Media Online</a></li>
                <li><a href="/berita/kliping" class="submenu-link">Kliping</a></li>
              </ul>
            </li>
          </ul>
          <ul class="menu-icon">
            <li class="has-dropdown" v-if="current_user" >
              <!-- Jika sudah login -->
              <div class="dropdown">
                <a href="#profil" class="dropdown-toggle menu-icon-link" data-toggle="dropdown">
                  <i class="fas fa-user-circle"></i>
                </a>
                <div class="dropdown-menu">
                  <a href="/publics/download" class="dropdown-item">
                    <span class="text">Riwayat Unduhan</span>
                  </a>
                  <a href="/requests" class="dropdown-item">
                    <span class="text">Riwayat Permohonan</span>
                  </a>
                  <a href="/requests/appeals" class="dropdown-item">
                    <span class="text">Riwayat Pengajuan Keberatan</span>
                  </a>
                  <a href="/publics/edit_profile" class="dropdown-item">
                    <span class="text">Edit Profil</span>
                  </a>
                  <a href="/users/sign_out" class="dropdown-item">
                    <span class="text">Logout</span>
                  </a>
                </div>
              </div>
              <!-- End of Jika sudah login -->
            </li>
            <li v-else>
              <!-- Jika belum login -->
              <a href="/publics/login" class="menu-icon-link">
                <i class="fas fa-user-circle"></i>
              </a>
              <!-- End of Jika belum login -->
            </li>
            <li>
              <a href="/data" class="menu-icon-link" data-toggle="tooltip" title="Pencarian">
                <i class="fas fa-search"></i>
              </a>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <!-- Notif -->
    <!-- bg-info: success -->
    <!-- bg-warning: warning -->
    <!-- bg-danger: alert / failed -->
    <div class="gk-notif bg-info" v-if="msg_notice">
      <span class="icon">
        <i class="fa fa-info"></i>
      </span>
      <span class="text">
        {{msg_notice}}
      </span>
      <span class="dismiss" @click="dismissNotif">
        <i class="fa fa-times"></i>
      </span>
    </div>
    <div class="gk-notif bg-danger" v-if="msg_alert">
      <span class="icon">
        <i class="fa fa-info"></i>
      </span>
      <span class="text">
        {{msg_alert}}
      </span>
      <span class="dismiss" @click="dismissAlert">
        <i class="fa fa-times"></i>
      </span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  import 'bootstrap';
  // import 'images/brands/logo-full-dark.png';

  export default {
    props: {
      isActive: '',
      current_user: '',
      msg_notice: null,
      msg_alert: null,
    },
    data() {
      return {
        // logo,
        toggleMenu: true,
        menuHeader: true,
        menuOpen: false,
      }
    },
    methods: {
      mobileMenuOpen() {
        this.toggleMenu = false;
        this.menuHeader = true;
        this.menuOpen = true;

        $(function() {
          $('[data-toggle="tooltip"]').tooltip();
        })
      },

      mobileMenuClose() {
        this.toggleMenu = true;
        this.menuHeader = false;
      },

      dismissNotif() {
        this.msg_notice = null;
      },
      dismissAlert() {
        this.msg_alert = null;
      }
    },
    mounted() {
      $('[data-toggle="tooltip"]').tooltip();
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../../../../app/assets/stylesheets/abstracts/variables';

  .gk-header {
    background-color: $secondary;
    color: #fff;

    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 70px;
    }

    .gk-logo {
      width: 180px;

      img {
        width: 100%;
      }
    }

    .gk-menu {
      display: flex;
      align-items: center;

      &.open {
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9;
        width: 300px;
        height: 100%;
        background: $text;
        color: #fff;

        .menu {
          flex-direction: column;
          align-items: baseline;
          width: 100%;
          height: auto;

          li {
            width: 100%;
            height: auto;
          }

          .menu-link {
            display: block;
            padding: 12px 20px;
            color: #fff;
            border-bottom: 1px solid rgba(255, 255, 255, .3);
          }
        }

        .menu-icon {
          margin-left: 0;
          width: 100%;
          border-left: 0;

          li {
            flex: 1;

            &:last-child .menu-icon-link {
              border-right: 0;
            }
          }

          .menu-icon-link {
            justify-content: center;
            background: transparent;
            height: 60px;
            color: #fff;
            border-bottom: 1px solid rgba(255, 255, 255, 0.4);
            font-size: 28px;
          }
        }

        .toggle-close {
          display: flex;
          align-self: flex-end;
          padding: 10px 15px;
          font-size: 24px;
          cursor: pointer;

          &:hover {
            opacity: .7;
          }
        }
      }

      @media (max-width: 1100px) {
        display: none;
      }
    }

    .menu {
      display: flex;
      align-items: center;
      list-style-type: none;
      margin: 0;
      padding: 0;
      height: 70px;

      li {
        height: 100%;
      }

      .menu-link {
        display: flex;
        align-items: center;
        padding: 0 15px;
        height: 100%;
        font-size: 16px;
        font-weight: 500;
        color: $text;

        &:hover {
          text-decoration: none;
          background: $secondary-hover;
        }
      }

      .active {
        .menu-link {
          background: $secondary-active;
        }
      }
    }

    .menu-icon {
      display: flex;
      align-items: center;
      list-style-type: none;
      margin-bottom: 0;
      padding: 0;
      height: 70px;
      border-left: 1px solid rgba(255, 255, 255, .4);

      li {
        height: 100%;
      }

      .menu-icon-link {
        display: flex;
        align-items: center;
        background: #e6ac0e;
        padding: 0 20px;
        height: 100%;
        font-size: 22px;
        color: $text;
        border-right: 1px solid rgba(255, 255, 255, .4);
      }

      .has-dropdown {
        .dropdown {
          height: 100%;
        }

        .dropdown-item {
          padding: 8px 20px;
          border-bottom: 1px solid #d1d1d1;

          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }

    .has-submenu {
      position: relative;

      .submenu {
        position: absolute;
        left: 0;
        z-index: 3;
        list-style-type: none;
        margin: 0;
        padding: 0;
        min-width: 240px;
        max-height: 0;
        background: $secondary-active;
        transition: all .2s ease-in-out;
        overflow-y: hidden;
      }

      .submenu-link {
        display: block;
        margin-bottom: -1px;
        padding: 12px 15px;
        border: 1px solid #da9017;
        color: $text;
        font-size: 14px;
        font-weight: 500;

        &:hover {
          text-decoration: none;
          background: $secondary;
        }
      }

      &:hover .submenu {
        max-height: 1000px;
        transition: all .3s ease-in-out;
      }
    }

    .gk-heading-menu {
      .container {
        height: 50px;
        min-height: 50px;
        justify-content: flex-start;

        @media (max-width: 767px) {
          flex-direction: column;
          padding: 0;
          height: auto;
        }
      }

      &.center {
        .container {
          justify-content: center;
        }
      }
    }
  }

  .toggle-menu-m {
    display: none;

    @media (max-width: 1100px) {
      display: flex;
      align-items: center;
      height: 70px;
      font-size: 34px;
      color: $text;
      cursor: pointer;
    }
  }

  .toggle-close {
    display: none;

    @media (max-width: 1100px) {
      display: flex;
    }
  }

  .gk-heading {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 140px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background: $text;
      opacity: .6;
    }

    .container {
      position: relative;
      z-index: 2;
    }

    .title {
      font-size: 34px;
    }

    &.center {
      .container {
        justify-content: center;
      }
    }
  }

  .gk-heading-menu {
    background: $footer-text;
    color: $text;

    .menu-link {
      display: flex;
      align-items: center;
      padding: 0 20px;
      height: 100%;
      border-left: 1px solid #bfced4;
      font-size: 15px;
      font-weight: 500;
      color: $text;

      &:last-child {
        border-right: 1px solid #bfced4;
      }

      &.active {
        background: #fff;
        pointer-events: none;
      }

      &:hover {
        background: #dce3e5;
        text-decoration: none;
      }

      @media (max-width: 767px) {
        width: 100%;
        padding: 10px 20px;
        border-left: 0;
        border-bottom: 1px solid #bfced4;

        &:last-child {
          border-right: 0;
        }
      }
    }

    .title {
      margin-bottom: 0;
      font-family: 'Roboto', sans-serif;
      font-size: 18px;
      font-weight: 500;
    }
  }

  .gk-notif {
    display: flex;
    align-items: center;
    padding: 10px 12px;

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      width: 20px;
      height: 20px;
      border: 1px solid #fff;
      border-radius: 50%;
    }

    .text {
      flex: 1;
      font-size: 15px;
    }

    .dismiss {
      margin-left: 10px;
      padding: 0 5px;
      cursor: pointer;
    }
  }
</style>
